import React from 'react';
import { motion } from 'framer-motion';
import { GavelIcon, LandmarkIcon, CpuIcon, CheckIcon } from 'lucide-react';
type Competency = {
  title: string;
  Icon: typeof GavelIcon;
  summary: string;
  points: string[];
};
const COMPETENCIES: Competency[] = [{
  title: 'Audit & Risk Committee Leadership',
  Icon: GavelIcon,
  summary: 'Active CPA (NY License #114833-1) with deep oversight of complex regulatory landscapes.',
  points: ['US GAAP & IFRS technical accounting', 'Internal controls and financial reporting integrity', 'Fed, OCC and SEC regulatory oversight']
}, {
  title: 'Capital Optimization & Fiscal Governance',
  Icon: LandmarkIcon,
  summary: 'Proven track record advising boards on capital, liquidity, and affiliate transaction governance.',
  points: ['Regulation W (23A / 23B) frameworks', 'Capital adequacy and liquidity oversight', 'High-level strategic board advisory']
}, {
  title: 'Modernization & Shared Services',
  Icon: CpuIcon,
  summary: 'Leader of enterprise platform transformation and global operating-model redesign.',
  points: ['Enterprise SAP S/4HANA rollouts', 'Process automation with Alteryx and Axiom', 'Global shared service migrations']
}];
export function Competencies() {
  return <section aria-labelledby="competencies-heading" className="w-full bg-slateink-100" data-id="element-28" data-mp="28k0cwojza8q8">
      <div className="mx-auto max-w-content px-6 py-20 sm:py-24 lg:px-8" data-id="element-29" data-mp="31airalq5jwiy">
        <h2 id="competencies-heading" className="text-[11px] font-semibold uppercase tracking-widest text-navy-700" data-id="element-30" data-mp="31ba98tqttvqr">
          Three Pillars of Board Contribution
        </h2>
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-slateink-600" data-id="element-31" data-mp="2reff0n1l6hia">
          A governance profile built for audit, risk, and finance committee mandates within
          regulated, globally systemic institutions.
        </p>

        <div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-3" data-id="element-32" data-mp="7x785gr2vtf2">
          {COMPETENCIES.map((item, i) => <motion.article key={item.title} initial={{
          opacity: 0,
          y: 22
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.55,
          delay: i * 0.1,
          ease: [0.22, 1, 0.36, 1]
        }} className="flex flex-col border-t-2 border-navy-900 bg-white p-8 shadow-[0_1px_2px_rgba(10,25,47,0.06)] transition-shadow duration-300 hover:shadow-[0_18px_40px_-24px_rgba(10,25,47,0.35)]" data-id="element-33" data-mp="bzlnhqvjgb1l" data-mpi={i}>
              <span className="flex h-11 w-11 items-center justify-center border border-slateink-300 text-navy-900" data-id="element-34" data-mp="3bfqnjionr4sg">
                <item.Icon className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" data-id="element-35" data-mp="3gds7s6xtla5i" />
              </span>
              <h3 className="mt-6 font-serif text-xl leading-snug text-navy-900" data-id="element-36" data-mp="31iclwp7e8kk7">
                {item.title}
              </h3>
              <p className="mt-4 text-sm leading-relaxed text-slateink-600" data-id="element-37" data-mp="2mtavhkpeomom">
                {item.summary}
              </p>
              <ul className="mt-6 space-y-3 border-t border-slateink-300/70 pt-6" data-id="element-38" data-mp="2it0smgwwucdz">
                {item.points.map(point => <li key={point} className="flex gap-3 text-sm text-navy-800" data-id="element-39" data-mp="2wt1u9yl01nui">
                    <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-gold-600" strokeWidth={2} aria-hidden="true" data-id="element-40" data-mp="2rrw0ryjilwjx" />
                    <span data-id="element-41" data-mp="31qbpxvyzevqs">{point}</span>
                  </li>)}
              </ul>
            </motion.article>)}
        </div>
      </div>
    </section>;
}